<template>
  <div>
    <!-- <h4 class="filter-title">Filter by date</h4> -->
    <h5>Start date</h5>
    <div class="date-wrapper">
      <datepicker
        name="startDate"
        v-model="startDate"
        placeholder="Start date"
        @selected="startDateSelected()"
        wrapper-class="date-picker"
        :disabledDates="disabledDates"
      ></datepicker>
      <span class="icon-calendar"></span>
    </div>
    <h5>End date</h5>
    <div class="date-wrapper">
      <datepicker
        name="endDate"
        v-model="endDate"
        placeholder="End date"
        @selected="endDateSelected()"
        :clear-button="true"
        wrapper-class="date-picker"
        :disabledDates="disabledDates"
      />
      <span class="icon-calendar"></span>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
var dayjs = require("dayjs");
var now = new Date();
var date = new Date();
var dayMinusDay = new Date(date.setDate(date.getDate() - 1));
// console.log(dayMinusDay);
// console.log(now);

export default {
  name: "DateFilter",
  props: ["date"],
  components: {
    Datepicker,
  },
  data() {
    return {
      startDate: now,
      endDate: null,
      disabledDates: {
        to: dayMinusDay,
      },
    };
  },
  methods: {
    startDateSelected(e) {
      this.$nextTick(() => {
        let date = dayjs(this.startDate).format("DDMMMYYYY");
        console.log(date);

        if (!date.includes("Invalid")) {
          this.$emit("update:startDate", date);
          this.$emit("updateUrl");
        } else {
          //  console.warn('broken date')
          this.$emit("update:startDate", "");
          this.$emit("updateUrl");
        }
      });
    },
    endDateSelected(e) {
      this.$nextTick(() => {
        let date = dayjs(this.endDate).format("DDMMMYYYY");
        console.log(date);

        if (!date.includes("Invalid")) {
          this.$emit("update:endDate", date);
          this.$emit("updateUrl");
        } else {
          //  console.warn('broken date')
          this.$emit("update:endDate", "");
          this.$emit("updateUrl");
        }
      });
    },
    clearStart() {
      console.log("clear start");
      this.startDate = null;
    },
  },
  created() {
    this.$emit("update:startDate", dayjs(now).format("DDMMMYYYY"));
  },
};
</script>

<style lang="scss" >
.date-filter {
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0 0;

  .filter-title {
    width: 100%;
  }
}
.date-wrapper {
  display: inline-block;
  position: relative;
  // margin-right: 1rem;
  width: 100%;
  margin-bottom: 1rem;

  .icon-calendar {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
}

input {
  border: 1px solid #b3b3b3;
  border-radius: 3px;
  padding: 0.5rem 70px 0.5rem 1rem;
  width: 100%;
}

.vdp-datepicker__clear-button {
  position: absolute;
  i {
    font-style: initial;
    &:before {
      position: relative;
      display: inline-block;
      content: "";
      font-family: "VicIcons";
      margin: 0 0.5em 0 0;
      width: 1em;
      vertical-align: -0.222em;
      text-align: center;
      line-height: 1;
    }
    span {
      display: none;
    }
  }
}

.vdp-datepicker {
  input {
    padding-left: 2rem;
  }
}
</style>
